import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as _ from 'lodash-es';

@Injectable({
  providedIn: 'root'
})
export class F4797Service {

  constructor(private http: HttpClient) { }

  fetchF4797Details(
    baseUrl: string, 
    rowData: any, 
    sso_id: string, 
    scenario: string, 
    jcd_key: number,
    globalService: any,
    filterParams: any = {}
  ): Observable<any> {
    const url = `${baseUrl}/loadJsonObject`;
    
    const params: any = {
      action_code: '5763v0',
      sso_id: sso_id,
      tax_year: rowData.TAX_YEAR,
      scenario: scenario,
      jcd_key: jcd_key,
      combination_key: rowData.COMBINATION_KEY,
      jcd_ta_key: null,
      issue_key: rowData.ISSUE_KEY
    };
    
    // Merge globalParams first, then filterParams (overrides), then specific params (same as AngularJS)
    const mergedParams = _.merge({}, globalService?.globalParams || {}, filterParams || {}, params);
    
    // Convert params to URLSearchParams for GET request
    let queryParams = new URLSearchParams();
    Object.keys(mergedParams).forEach(key => {
      if (mergedParams[key] !== undefined && mergedParams[key] !== null) {
        queryParams.set(key, mergedParams[key].toString());
      }
    });
    
    return this.http.get<any>(`${url}?${queryParams.toString()}`, { withCredentials: true });
  }

  saveForm4797(
    baseUrl: string,
    final_data: any[],
    clob_settings: any[],
    globalService: any,
    filterParams: any = {},
    rowData: any = {}
  ): Observable<any> {
    const url = `${baseUrl}/saveJsonObject?action_code=p4i3se`;
    
    let params = _.merge({}, globalService?.globalParams || {}, filterParams);
    
    params.json_data = JSON.stringify(final_data);
    params.json_settings = JSON.stringify(clob_settings);
    params.process_name = "form-4797-save";
    
    // Add essential parameters with fallbacks
    params.tax_year = filterParams.tax_year || params.tax_year || rowData.TAX_YEAR;
    params.scenario = filterParams.scenario || params.scenario;
    params.jcd_key = filterParams.jcd_key || params.jcd_key || rowData.JCD_KEY || 250;
    params.scenarioCode = filterParams.scenarioCode || filterParams.scenario_code || params.scenarioCode || "RAF";
    params.is_issue_key_enabled = "N";
    
    // Build checkLockedbj using real rowData (includes me_code)
    const checkLockedbj = [{
      "leid": rowData.LEID,
      "cdr_number": rowData.CDR_NO || rowData.MARS,
      "me_code": rowData.ME_CODE || rowData.me_code || '',
      "consol_group_key": String(rowData.CONSOL_GROUP_KEY || ''),
      "reporting_period": String(rowData.REPORTING_PERIOD || ''),
      "combination_key": String(rowData.COMBINATION_KEY),
      "scenario_key": parseInt(filterParams.scenario || params.scenario || '74')
    }];
    params.checkLockedbj = JSON.stringify(checkLockedbj);
    
    // Convert to URLSearchParams for application/x-www-form-urlencoded
    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        urlEncoded.set(key, params[key].toString());
      }
    });
    
    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });
    
    return this.http.post<any>(url, urlEncoded.toString(), { headers, withCredentials: true });
  }

  getSectionTypes(
    baseUrl: string,
    sso_id: string,
    rowData: any,
    globalService: any,
    filterParams: any
  ): Observable<any> {
    const url = `${baseUrl}/loadJsonObject?action_code=2h8gm0`;
    
    const params: any = {
      sso_id: sso_id,
      cc_key: rowData.COMBINATION_KEY,
      tax_year: rowData.TAX_YEAR,
      scenario: globalService?.globalParams?.scenario || '',
      jcd_key: rowData.JCD_KEY || 250
    };
    
    // Merge globalParams first, then filterParams (overrides), then specific params (same as AngularJS)
    // AngularJS: params = _.merge({}, GlobalService.globalParams, filterParams);
    const mergedParams = _.merge({}, globalService?.globalParams || {}, filterParams || {}, params);
    
    // Convert params to URLSearchParams for GET request
    let queryParams = new URLSearchParams();
    Object.keys(mergedParams).forEach(key => {
      if (mergedParams[key] !== undefined && mergedParams[key] !== null) {
        queryParams.set(key, mergedParams[key].toString());
      }
    });
    
    return this.http.get<any>(`${url}&${queryParams.toString()}`, { withCredentials: true });
  }
}

